import { Colors } from '@oy/uicore';
import {
  Button,
  FieldContainer,
  Modal,
  Padder,
  Select,
  Spacer,
} from '@oy/uidesktop';
import { SystemIcon } from '@oy/uiicon';
import { first } from 'lodash-es';
import { ReactNode } from 'react';
import { EXPORT_OPTIONS } from 'src/constants';
import { useTranslate } from 'src/hooks';
import { RECORDS_TABLE_ID } from './constant';
import styles from './ExportReportsModal.module.css';

type ExportReportsModalProps = {
  show: boolean;
  onClose: () => void;
  title: string;
  from: string;
  contentNotify: string[];
  titleNotify?: string;
  onChangeFileType: (value: string) => void;
  onClickExport: () => void;
  extraButtonExportModal?: ReactNode;
  exportType: string;
};

export const ExportReportsModal = ({
  show,
  onClose,
  title,
  from,
  contentNotify,
  extraButtonExportModal,
  titleNotify,
  onChangeFileType,
  onClickExport,
  exportType,
}: ExportReportsModalProps) => {
  const { getTranslation } = useTranslate();
  return (
    <Modal show={show} onClose={onClose} className={styles.modal}>
      <Modal.Header showCloseButton showDivider>
        {getTranslation('recordsTable_modalHeader_export')} {title}
      </Modal.Header>
      <Modal.Body>
        {/*  TODO: Instead of conditional render, pass the element directly trough props to reduce complexity e.g. `extraButtonExportModal` */}
        {from === 'detailbulk' && (
          <div className={styles.notify}>
            <div>
              <Padder color={Colors.AMETHYST100} all={Padder.Size.XS}>
                <div className={styles.notifyContainer}>
                  <div className={styles.icon}>
                    <SystemIcon
                      name="information-filled"
                      color={Colors.BLUE100}
                      size={30}
                    />
                  </div>
                  <div className={styles.notifyText}>
                    <div>{titleNotify}</div>
                    {contentNotify.map(c => (
                      <div>● {c}</div>
                    ))}
                  </div>
                </div>
              </Padder>
            </div>
          </div>
        )}
        <Select
          idParent={RECORDS_TABLE_ID.IPT_EXPORT_FILE_TYPE}
          id={`${RECORDS_TABLE_ID.LST_EXPORT_FILE}${exportType.toUpperCase()}`}
          label={getTranslation('common_fileType')}
          isHorizontal
          defaultValue={first(EXPORT_OPTIONS)}
          onChange={e => onChangeFileType(e.value)}
          options={EXPORT_OPTIONS}
        />
        <FieldContainer label=" " isHorizontal>
          <Spacer top={Spacer.Size.M}>
            <Button
              onClick={onClickExport}
              type="button"
              id={RECORDS_TABLE_ID.BTN_EXPORT_DATA}
            >
              {getTranslation('recordsTable_button_export')}
            </Button>
            {extraButtonExportModal}
          </Spacer>
        </FieldContainer>
      </Modal.Body>
    </Modal>
  );
};
